<template>
  <div>
    <div class="info-wrapper">
      <div class="title" style="font-size:14px;">保证金信息</div>
      <div class="info-item">
        <span class="title">所属银行：</span>
        <span>{{depositData.bank}}</span>
        <span class="title" style="margin-left:50px;">金额：</span>
        <span>{{depositData.amount}}</span>
        <span class="title" style="margin-left:50px;">交易日期：</span>
        <span>{{depositData.dealTime | filterTime}}</span>
      </div>
      <div class="info-item">
        <span class="title">对方户名：</span>
        <span>{{depositData.ghfAccountName}}</span>
        <span class="title" style="margin-left:50px;">对方账号：</span>
        <span>{{depositData.ghfAccount}}</span>
      </div>
      <div class="info-item">
        <span class="title">摘要：</span>
        <span>{{depositData.digest}}</span>
        <span class="title" style="margin-left:30px;">备注：</span>
        <span>{{depositData.comment}}</span>
      </div>
    </div>
    <div class="search-wrapper">
      <span>项目编号：</span>
      <Input v-model="search.numFull" style="width:120px;margin-right:5px;"></Input>
      <span>项目简编：</span>
      <Input v-model="search.numAbbr" style="width:80px;margin-right:5px;"></Input>
      <span>投标单位：</span>
      <Input v-model="search.companyName" style="width:220px;margin-right:5px;"></Input>
      <Button type="primary" size="small" @click="searchEnroll">搜索</Button>
    </div>
    <Table :columns="columns" :data="enrollList" style="margin-top:5px;"></Table>
    <Page :total="total" show-elevator show-total :page-size="8" style="margin-top:5px;" @on-change="pageChange"></Page>
    <Modal v-model="groupChooseVisible" title="包组选择" :transfer="false" :mask-closable="false">
      <div>
        <div v-for="group in groupList" style="min-height:35px;line-height:35px;">
          <Checkbox v-model="group.isChoose" @on-change="chooseChange">包组{{group.groupNo}}：{{group.groupName}}
            <span style="color:#19be6b">（应收保证金：{{group.marginAmount}}）</span>
          </Checkbox>
          <span v-if="group.isChoose">
            <span>金额：</span>
            <Input v-model="group.fee" style="width:100px;"></Input>
            <span>元</span>
          </span>
        </div>
      </div>
      <div slot="footer">
        <Button @click="groupChooseVisible=false">取消</Button>
        <Button type="primary" @click="receiveDeposit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  props: {
    depositData: {
      type: Object
    }
  },
  data() {
    return {
      columns: [
        {
          title: '投标单位',
          key: 'companyName'
        },
        {
          title: '项目编号',
          key: 'projectFull',
          width: 180
        },
        {
          title: '操作',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (params.row.groupId.length === 0) {
                      this.$Message.error('无包组')
                      return
                    }
                    if (this.depositData.ghfAccountName !== params.row.companyName) {
                      this.$Modal.confirm({
                        title: '户名不一致',
                        content: '你当前选择的项目单位名称与对方户名不一致，请再次确认',
                        onOk: () => {
                          this.selectEnroll = params.row
                          this.getGroup(params.row.groupId)
                          this.groupChooseVisible = true
                        }
                      })
                      return
                    }
                    this.selectEnroll = params.row
                    this.getGroup(params.row.groupId)
                    this.groupChooseVisible = true
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      enrollList: [],
      total: 0,
      search: {
        numAbbr: '',
        numFull: '',
        companyName: ''
      },
      groupChooseVisible: false,
      groupList: [],
      selectEnroll: {}
    }
  },
  methods: {
    async getEnroll(page, { companyName = '', numFull = '', numAbbr = '' }) {

      let defaultSear = ' and e.status == "3"' // 只获取报名成功的
      let companySear = companyName ? ` and e.companyName.contains("${companyName}")` : ''
      let numFullSear = numFull ? ` and e.projectFull.contains("${numFull}")` : ''
      let numAbbrSear = numAbbr ? ` and e.projectShort.contains("${numAbbr}")` : ''

      let filter = defaultSear + companySear + numFullSear + numAbbrSear
      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.enroll.GetPagedWithoutRole, {
        params: {
          filter: filter,
          sort: 'creationTime desc',
          maxResultCount: 8,
          skipCount: (page - 1) * 8
        }
      })
      if (rep.data.success) {
        this.total = rep.data.result.totalCount
        this.enrollList = rep.data.result.items
      }
    },
    async getGroup(groupId = '') {
      let groupIds = []
      if (groupId.indexOf(',') !== -1) {
        groupIds = groupId.split(',')
      } else {
        groupIds[0] = groupId
      }
      let filter = ''
      groupIds.forEach(group => {
        filter += ` or id == "${group}"`
      })
      filter = filter.slice(4)
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: filter,
          sorting: '',
          maxResultCount: 500, // 获取全部包组
          skipCount: 0,
        }
      })
      if (rep.data.success) {
        this.groupList = []
        rep.data.result.items.forEach(item => {
          item.isChoose = false
          item.fee = ''
          this.groupList.push(item)
        })
      }
    },
    searchEnroll() {
      this.getEnroll(1, this.search)
    },
    pageChange(page) {
      this.getEnroll(page, this.search)
    },
    async receiveDeposit() {
      // 查询是否已领取。避免重复领取
      // this.$Spin.show()
      // try {
      //   let orderRep = await ajax.get(requestUrls.order.getPaged, {
      //     params: {
      //       filter: `clMarginId=="${this.depositData.id}" and orderType == "保证金"`,
      //       sorting: 'orderNo',
      //       maxResultCount: 100,
      //       skipCount: 0,
      //     }
      //   })
      //   this.$Spin.hide()
      //   if (!orderRep.data.success) {
      //     this.$Message.error('查询领取情况失败')
      //     return
      //   }
      //   if (orderRep.data.success && orderRep.data.result.items.length > 0) {
      //     // 只判断第一条，多条几率低
      //     let judgeOrder = orderRep.data.result.items[0]
      //     if (judgeOrder.orderAmountTotal >= this.depositData.amount) {
      //       this.$Message.info('此保证金信息金额已领取完毕，请查看领取详情')
      //       return
      //     }
      //   }
      // } catch (err) {
      //   console.error(err)
      //   this.$Message.error('查询领取情况失败')
      //   return
      // }

      this.$Spin.show()
      let canReceive = await this.ifMarginExists()
      this.$Spin.hide()
      if (canReceive) {
        this.confirmOrders()
        return
      }
      this.$Modal.confirm({
        title: '重复领取',
        content: '已领取过此条保证金信息，再次领取将会导致重复，请仔细确认。',
        okText: '继续',
        onOk: () => {
          this.confirmOrders()
        }
      })
      
    },
    // 检查重复
    async ifMarginExists() {
      let examineList = []
      for (let i = 0; i < this.groupList.length; i++) {
        let group = this.groupList[i]
        if (group.isChoose) {
          if (group.fee === '') {
            this.$Message.error('请输入选中包组保证金金额')
            return
          } else {
            let examineOrder = {
              projectId: group.projectId,
              groupId: group.id,
              bankName: this.depositData.ghfAccountName,
              amount: group.fee
            }
            examineList.push(examineOrder)
          }
        }
      }
      let rep = await ajax.post(requestUrls.order.MarginExistsList, examineList)

      if (rep.data.success) {
        return rep.data.result
      }

      return false
    },
    // 提交订单
    async confirmOrders() {
      let orderList = []
      let orderItem = {
        "orderStatus": "2",
        "orderAmountTotal": 0,
        "marginSeqNo": this.depositData.bankSeqNo,
        "redOrderNo": "",
        "orderType": "保证金",
        "ghfInvoiceTaxNo": this.selectEnroll.companyNo,
        "ghfCompanyName": this.selectEnroll.companyName,
        "ghfCompanyAddress": this.selectEnroll.companyAddress,
        "ghfTelphone": this.selectEnroll.companyTel,
        "ghfBankName": this.selectEnroll.openBank,
        "ghfBankAccount": this.selectEnroll.openAccount,
        "xhfInvoiceTaxNo": "",
        "xhfCompanyName": "",
        "xhfCompanyAddress": "",
        "xhfTelphone": "",
        "xhfBankName": "",
        "xhfBankAccount": "",
        "projectFull": this.selectEnroll.projectFull,
        "district": this.selectEnroll.district,
        "payChannel": this.depositData.bank,
        "payTime": this.depositData.dealTime,
        "confirm": this.$store.state.session.user.name,
        "clMarginId": this.depositData.id,
        "enrollId": this.selectEnroll.id,
        "abpOrdersExp": {
          "bankName": this.depositData.ghfAccountName,
          "bankAccount": this.depositData.ghfAccount,
          "projectId": 0,
          "groupId": 0,
          "groupName": ""
        },
        "projectId": this.selectEnroll.projectId
      }
      // 遍历填写
      for (let i = 0; i < this.groupList.length; i++) {
        let group = this.groupList[i]
        if (group.isChoose) {

          if (group.fee === '') {
            this.$Message.error('请输入选中包组保证金金额')
            return
          } else {
            let orderItemCopy = JSON.parse(JSON.stringify(orderItem))
            orderItemCopy.abpOrdersExp.projectId = group.projectId
            orderItemCopy.abpOrdersExp.groupId = group.id
            orderItemCopy.abpOrdersExp.groupName = group.groupName
            orderItemCopy.orderAmountTotal = group.fee
            orderList.push(orderItemCopy)
          }

        }
      }
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.order.MarginOrdersList, orderList)
        this.$Spin.hide()
        if (rep.data.success) {
          this.groupChooseVisible = false
          this.$emit('receiveSuccess')
          this.$Message.success('操作成功')
        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    // 单个选择默认一个，多个清空
    chooseChange() {
      // 数字全部清空
      this.groupList.map(group => {
        if (group.fee === this.depositData.amount) {
          group.fee = ''
        }
      })
      let isOne = false
      // 记录第一个清空
      let fillGroup = ''
      for (let i = 0; i < this.groupList.length; i++) {
        let group = this.groupList[i]
        if (group.isChoose) {
          if (!isOne) {
            group.fee = this.depositData.amount
            fillGroup = group
            isOne = true
          } else {
            fillGroup.fee = ''
            break
          }
        }
      }
    }
  },
  watch: {
    depositData(val) {
      if (val) {
        this.search.numAbbr = ''
        this.search.numFull = ''
        this.search.companyName = val.ghfAccountName
        this.enrollList = []
        this.getEnroll(1, this.search)
      }
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return '无'
      }
      return val.split('T')[0]
    }
  }
}
</script>

<style lang="less" scoped>
.info-wrapper {
  padding: 5px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  .title {
    font-weight: bold;
  }
  .info-item {
    margin-top: 5px;
  }
}
</style>
